export type DetectedContext = {
    isWebShop: boolean;
    isMobileShop: boolean;
    device: DeviceEnum;
    customerType: CustomerEnum;
};

export enum CustomerEnum {
    Company = "Company",
    Private = "Private",
    Surgery = "Surgery"
}

export enum DeviceEnum {
    Desktop = "desktop",
    Kiosk = "kiosk",
    Phone = "phone",
    Tablet = "tablet",
    None = "none"
}

export enum MobileOsEnum {
    Android = "android",
    Ios = "ios",
    None = "none"
}
